import { render, staticRenderFns } from "./TechSupportCard.vue?vue&type=template&id=32ec46a2&scoped=true&"
import script from "./TechSupportCard.vue?vue&type=script&lang=js&"
export * from "./TechSupportCard.vue?vue&type=script&lang=js&"
import style0 from "./TechSupportCard.vue?vue&type=style&index=0&id=32ec46a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec46a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
